import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const revealSelector = [
  ".page-container > *",
  "section",
  "article",
  ".content-container > *",
].join(", ");

const ScrollReveal = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    const elements = [...document.querySelectorAll(revealSelector)].filter(
      (element) => !element.closest(".navbar"),
    );

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      elements.forEach((element) => element.classList.add("is-revealed"));
      return undefined;
    }

    let lastScrollY = window.scrollY;
    let isScrollingDown = true;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY !== lastScrollY) {
        isScrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    const setRevealDirection = (element) => {
      element.classList.toggle("reveal-from-bottom", isScrollingDown);
      element.classList.toggle("reveal-from-top", !isScrollingDown);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setRevealDirection(entry.target);

          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
          } else {
            entry.target.classList.remove("is-revealed");
          }
        });
      },
      {
        threshold: 0.01,
        rootMargin: "120px 0px 120px 0px",
      },
    );

    elements.forEach((element) => {
      element.classList.add("scroll-reveal");
      observer.observe(element);
    });

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  return null;
};

export default ScrollReveal;
